<div class="form-container">

  <h1 class="ion-text-center ion-margin-bottom">
    Cuéntanos un poco más
  </h1>
  <div class="ion-margin-top ion-padding-top">
    <app-form [questions]="signupQuestions" (submit)="continue()"></app-form>
    <ion-item lines="none" >
      <ion-checkbox labelPlacement="end" aria-labelledby="terms-lbl" [(ngModel)]="allowSMS" (ionChange)="onSMSChange()"></ion-checkbox>
      <ion-label class="ion-padding-start ion-text-wrap" id="terms-lbl">
        Acepto recibir notificaciones por SMS
      </ion-label>
    </ion-item>

    <ion-item lines="none">
      <ion-checkbox labelPlacement="end" aria-labelledby="priv-lbl" [(ngModel)]="allowEmail" (ionChange)="onEmailChange()"></ion-checkbox>
      <ion-label class="ion-padding-start ion-text-wrap" id="priv-lbl">
        Acepto recibir notificaciones por correo electrónico
      </ion-label>
    </ion-item>
  </div>

  <ion-grid>
    <ion-row *ngIf="!loading">
      <ion-col size="8" sizeMd="6" style="margin: auto;">
        <ion-button expand="block" class="ion-text-wrap" fill="clear" (click)="goBack()">
          Volver
        </ion-button>
      </ion-col>
      <ion-col size="8" sizeMd="6" style="margin: auto;">
        <ion-button expand="block" class="ion-text-wrap" (click)="continue()">
          Continuar
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="loading">
      <ion-col size="8" sizeMd="6" class="ion-text-center" style="margin: auto;">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>

</div>